import { Component } from '@angular/core';

@Component({
  selector: 'via-methodology',
  templateUrl: './methodology.component.html',
  styleUrls: ['./methodology.component.scss']
})
export class MethodologyComponent {
}
